module.exports = __webpack_public_path__ + "img/kkb_ethercon.c528c508.jpg";